import React, { FC } from 'react';

import { HotelCard, Spinner } from '../../../../components';
import { useGetHotelDocumentFromFirestore, useQueryHelper } from '../../../../queries';
import { HotelDetails } from '../../../../queries/organizationsQueryFirebase/types';
import { HotelDocumentFirestoreResponse } from '../../../../types';

interface HotelDataInformationProps {
  hotelId: string;
  hotel?: HotelDetails | null;
}

const toCard = (hotel: HotelDetails): HotelDocumentFirestoreResponse => ({
  id: hotel.id,
  name: hotel.name,
  brand_url: hotel.brand_url,
  cover_photo: hotel.cover_photo,
  email: hotel.email,
  phone: hotel.phone,
  address: {
    city_name: hotel.address.city_name,
    city: hotel.address.city,
    number: hotel.address.number,
    street: hotel.address.street,
    postal_code: hotel.address.postal_code,
  },
  stars: hotel.stars,
  chatAvailable: hotel.chatAvailable,
  mobileAppAvailable: hotel.mobileAppAvailable,
});

export const HotelDataInformation: FC<HotelDataInformationProps> = (props) => {
  const { hotelId, hotel: hotelFromParent } = props;
  const hotelQuery = useGetHotelDocumentFromFirestore(hotelFromParent ? undefined : hotelId);

  const { data: hotelFetched } = hotelQuery;
  const { isLoading, isError, errorMessage } = useQueryHelper({
    queries: hotelFromParent ? [] : [hotelQuery],
  });

  const hotel = hotelFromParent ? toCard(hotelFromParent) : hotelFetched;

  if (!hotelId) {
    return null;
  }

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <p className="text-red-500">
        {errorMessage }
      </p>
    );
  }

  return (
    <div>
      <HotelCard data={hotel} />
    </div>
  );
};
